export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Archivos y Documentacion</h2>
          {/* <p>
            Los siguientes archivos son documentos con la Resolución Ministerial, reglamentación, ejemplos de archivos requeridos, etc.
          </p> */}
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-6'>
                  {' '}
                  <i className={d.icon}></i>
                  <h3><a href={d.link}>{d.name}</a></h3>
                  <div className='service-desc'>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
